// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_3j-2";
export var cell = "_3j-6";
export var cellContainer = "_3j-3";
export var disabled = "_3j-5";
export var featuredIconCellContainer = "_3j-7";
export var featuredIconTextContainer = "_3j-9";
export var featuredIconWrapper = "_3j-8";
export var hasRowsSelected = "_8b-1";
export var noBorder = "_3j-a";
export var overflowableText = "_3j-0";
export var overflowableTextContainer = "_3j-1";
export var row = "_3k-0";
export var rowCheckboxCell = "_3j-4";
export var selectableTable = "_8b-2";